import { PickupForm } from "@features/pickups/components/PickupForm";
import { usePickups } from '@features/pickups/hooks/usePickups';
import HeadLayout from "@shared/layouts/HeadLayout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PICKUP_TOAST_KEYS, PICKUP_ROUTES } from "../constants";

const CreatePickup = () => {
  const { t } = useTranslation();
  const { createPickup } = usePickups();

  const navigate = useNavigate();

  const handleCreatePickup = (values) => {
    const toastId = toast.loading(t(PICKUP_TOAST_KEYS.CREATING));
    createPickup(values, {
      onSuccess: () => {
        toast.success(t(PICKUP_TOAST_KEYS.CREATED_SUCCESS), { id: toastId });
        navigate(PICKUP_ROUTES.LIST);
      },
      onError: (error) => {
        console.error(error);
        toast.error(error.response?.data?.message || t("pickups.pickupNotCreated"), { id: toastId });
      },
    });
  };

  return (
    <>
         <HeadLayout title={t("pickups.addPickup")} />
      <PickupForm onSubmit={handleCreatePickup} />
    </>

  
  );
};

export default CreatePickup;
